export default __webpack_public_path__ + "static/retirement-image-c55fffa7315ce7f78d12d17d98a077d6.jpg";